export default (italic: boolean | undefined): 'italic' | 'normal' =>
  italic ? 'italic' : 'normal';
